import React from "react";

export default function StoryAndPerrys() {
  return (
    <section className="sd-story-panel" data-testid="story-section">
      <div className="grid md:grid-cols-2 gap-0">
        {/* Our Story */}
        <div className="p-12 md:p-16 flex items-center" data-testid="our-story-block">
          <div>
            <h2 className="text-white text-4xl md:text-5xl mb-5 font-display">Our Story</h2>
            <p className="text-white/95 leading-relaxed text-lg max-w-md">
              For over 40 years the Milani Family has owned and operated the
              first and only Sub Shop in Lockport — and it is on its way to
              enter another 40 years of service.
            </p>
          </div>
        </div>
        <div className="relative">
          <img
            src="/images/ourstory.jpg"
            alt="Our Story"
            className="w-full h-72 md:h-full object-cover"
            data-testid="our-story-image"
          />
        </div>

        {/* Perry's Ice Cream */}
        <div className="order-3 relative">
          <img
            src="/images/perrysicecream.jpg"
            alt="Perry's Ice Cream"
            className="w-full h-72 md:h-full object-cover"
            data-testid="perrys-image"
          />
        </div>
        <div className="order-4 bg-[#2d8a86] p-12 md:p-16 flex items-center" data-testid="perrys-block">
          <div>
            <h2 className="text-white text-4xl md:text-5xl mb-5 font-display">Perry's Ice Cream</h2>
            <p className="text-white/95 leading-relaxed text-lg max-w-md">
              A special selection of flavors is now available exclusively at our
              Rochester Rd. Shop. Don't forget to order your favorite item the
              next time you stop by.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
